/**
 * Geometry shared by every block on a traffic surface.
 *
 * The blocks are separate charts stacked vertically, and the whole point of the
 * stack is that a reader can drop a vertical line through it — a discard burst
 * sitting on a traffic knee is the finding. That only works if the plot areas
 * start at the same x, which means every chart reserving exactly the same
 * left-hand gutter, whether or not it prints ticks in it.
 */
export const Y_AXIS_WIDTH = 88;

export const CHART_MARGIN = { top: 6, right: 12, bottom: 0, left: 0 };

/**
 * Ticks for a mirrored axis, symmetric about a labelled zero.
 *
 * Recharts must not be left to choose these. Given a domain of `[-b, +b]` it
 * picks its own "nice" values, and they come out asymmetric and without a zero
 * — measured on a real port: `+40.4M, +15.4M, -9.6M, -40.4M`. Every tick label
 * on a mirror prints its magnitude, because the sign *is* the direction
 * channel, so that set renders as `40.4M, 15.4M, 9.6M, 40.4M`: not monotonic,
 * no midpoint, and no way to tell which half of the plot is which.
 *
 * Zero is the whole geometry of this chart. It gets a tick.
 */
export function mirroredTicks(bound: number): number[] {
  return [-bound, -bound / 2, 0, bound / 2, bound];
}

/**
 * One crosshair across every block on the surface.
 *
 * Every chart carrying this must also set `syncMethod="value"`. Recharts syncs
 * by array *index* by default, and the event rail plots two points where the
 * charts above it plot several hundred — index-matching would put the rail's
 * crosshair at the wrong time entirely, which is worse than not syncing at all
 * because it looks like it worked.
 */
export const SYNC_ID = 'interface-traffic';
